module.exports = __webpack_public_path__ + "img/oct_23.96c329b2.png";